import React from 'react'
import { useTracking } from 'react-tracking'

import Heading from '../../atoms/ApartmentCard/Heading'

import Address from '../../atoms/ApartmentCard/Address'
import Body from '../../atoms/ApartmentCard/Body'
import BedroomList from '../../atoms/ApartmentCard/BedroomList'
import ApartmentCard from '../../atoms/ApartmentCard/Card'
import SpecialTag from '../../atoms/ApartmentCardVersion2/SpecialTag'

import AmenityList from '../../molecules/ApartmentCard/AmenityList'
import Bedroom from '../../molecules/ApartmentCard/Bedroom'
import ButtonGroup from '../../molecules/ApartmentCard/ButtonGroup'
import Image from '../../molecules/ApartmentCardVersion2/Image'
import ImageContainer from '../../molecules/ApartmentCardVersion2/ImageContainer'

import ImageCarousel from '../ImageCarousel'

const Card = props => {
  useTracking({ apartment: props.name, position: props.position }, {
    dispatchOnMount: () => ({ category: 'Impression', event: 'Apartment Card View', label: '' }),
  })

  const {
    isGrid,
    carousel,
    specialTag,
    openWebsite,
    name,
    address,
    priceSummary,
    marketingWebsiteUrl,
    prospectPhoneNumber,
    termGroups,
    showPopup,
  } = props

  return (
    <ApartmentCard>
      <ImageCarousel>
        {carousel.map(({ url: imageSrc, alt }, index) =>
          <ImageContainer key={index} isGrid={isGrid} onClick={openWebsite}>
            <Image src={imageSrc} alt={alt} />
            {specialTag ? <SpecialTag>{specialTag}</SpecialTag> : null}
          </ImageContainer>
        )}
      </ImageCarousel>
      <Body>
        <Heading as='h3'>{name}</Heading>
        <Address address={address} />
        <AmenityList amenities={termGroups} />
        <BedroomList>
          {priceSummary.map((b, i) => (
            <Bedroom key={i} n={b.bedrooms} amount={b.min ? b.min.effectiveRent.min : 0} />
          ))}
        </BedroomList>
        <ButtonGroup
          website={marketingWebsiteUrl}
          phone={prospectPhoneNumber}
          showPopup={showPopup}
        />
      </Body>
    </ApartmentCard>
  )
}

export default Card
